import React, { FC, useMemo } from 'react';

import Button from 'src/common/components/Button';
import Modal from 'src/common/components/Modal';
import { NEW_TAB_ATTRIBUTES, EXTERNAL_PATHS } from 'src/common/constants';
import { useOffSeasonSummaryContext } from '../../hooks/useOffSeasonSummary';

import s from './OffSeasonSummaryModal.module.scss';

const OffSeasonSummaryModal: FC = () => {
  const { selectedBoatHash, closeSummary } = useOffSeasonSummaryContext();

  const pricingPath = useMemo(() => {
    if (!selectedBoatHash) {
      return EXTERNAL_PATHS.ADMIN_PRICING;
    }
    return `${EXTERNAL_PATHS.ADMIN_PRICING}${selectedBoatHash}/`;
  }, [selectedBoatHash]);

  return (
    <Modal
      name="offSeasonSummary"
      label="Off season summary"
      closeModal={closeSummary}
      modalOpen={Boolean(selectedBoatHash)}
      classNameModifier="calendar unavailableEditor"
      size="large"
    >
      <div className={s.root}>
        <div className={s.header}>
          <p className={s.title}>Unavailable</p>
          <p className={s.subtitle}>Nothing to book.</p>
        </div>
        <div className={s.body}>
          <p className={s.message}>
            Configure{' '}
            <a
              href={pricingPath}
              {...NEW_TAB_ATTRIBUTES}
            >
              pricing
            </a>
            {' '}for this date to make it available.
          </p>
        </div>

        <div className={s.footer}>
          <Button
            type="button"
            fullWidth
            classNameModifier="noMargin"
            onClick={closeSummary}
          >
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default OffSeasonSummaryModal;
